import { render, staticRenderFns } from "./DirectViewerSkeleton.vue?vue&type=template&id=22b368bf&"
import script from "./DirectViewerSkeleton.vue?vue&type=script&lang=js&"
export * from "./DirectViewerSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports